<template>
    <div class="monitor monitorPage">
        <MyHeader />
        <div class="page-left flex flex-direction">
            <div class="flex justify-between">
                <div class="left-p1">
                    <Part1 />
                    <Part2 />
                    <Part3 />
                </div>
                <div class="left-p1">
                    <Part4 />
                </div>
            </div>
            <div class="mt-30">
                <Part5 />
            </div>
        </div>
        <div class="page-center">
            <MyNumber />
            <Part6 class="mt-50" />
            <Part7 class="mt-30" />
        </div>
        <div class="page-right flex justify-between">
            <div class="left-p1">
                <Part8 />
                <Part9 class="mt-30" />
                <Part10 class="mt-50" />
            </div>
            <div class="left-p1">
                <Part11 />
            </div>
        </div>
    </div>
</template>

<script>
import MyHeader from './../../components/myHeader1.vue'
import MyNumber from '../../components/myNumbers.vue'
import Part1 from './../../components/part-m1.vue'
import Part2 from './../../components/part-m2.vue'
import Part3 from './../../components/part-m3.vue'
import Part4 from './../../components/part-m4.vue'
import Part5 from './../../components/part-m5.vue'
import Part6 from './../../components/part-m6.vue'
import Part7 from './../../components/part-m7.vue'
import Part8 from './../../components/part-m8.vue'
import Part9 from './../../components/part-m9.vue'
import Part10 from './../../components/part-m10.vue'
import Part11 from './../../components/part-m11.vue'
export default {
    components: {
        MyHeader,
        MyNumber,
        Part1,
        Part2,
        Part3,
        Part4,
        Part5,
        Part6,
        Part7,
        Part8,
        Part9,
        Part10,
        Part11
    },
    data() {
        return {
            timer: null
        }
    },
    mounted() {
        this.timer = setInterval( item => {
            let newDate = new Date()
            let h = newDate.getHours()
            let m = newDate.getMinutes()
            let s = newDate.getSeconds()
            // console.log(h, m , s , 'newDate')
            if(!m && !s && [0, 4, 8, 12, 20].includes(h)) {
                location.reload()
            }
        }, 1000)
    },
    destroyed() {
        clearInterval(this.timer)
    }
}
</script>

<style lang="scss" scoped>
@import './../../components/comm.scss';
.monitor {
    padding: 0 50px;
    .left-p1 {
        width: 455px;
    }
}
</style>